import { dataSender, getData, getRoute, htmlFormSend, navigateV2 } from '../../../../../../common/utils/router';
import T, { t } from '../../../../../../common/components/T';
import { API_SERVER_URL, SITE_URL } from '../../../../../../common/utils/utils';
import moment from 'moment/moment';
import { zendoStorage } from '../../../../../../hybrid/wrappers';
import axios from 'axios';

export const getStoreFormData = (formsData) =>
    Object.keys(formsData).reduce((accum, formGroupAlias) => {
        accum[formGroupAlias] = {
            title: formsData[formGroupAlias].title,
            fields: formsData[formGroupAlias].fields
        };

        return accum;
    }, {});

export const setFormDataMainFunc = (key, val, setStoreData, setSelectedPaymentSystems) => {
    if (typeof val === 'string' && val.length === 0) {
        setStoreData((pre) =>
            Object.keys(pre).reduce((accum, keyFormData) => {
                if (key !== keyFormData) accum[keyFormData] = pre[keyFormData];
                return accum;
            }, {})
        );
    } else {
        if (key === 'recipient_type') {
            setStoreData((pre) => ({
                ...pre,
                [key]: val === '1' ? 'third_person' : val === '0' ? 'me' : 'third_person'
            }));
        } else if (key === 'delivery_method_price_id') {
            setStoreData((pre) => ({
                ...pre,
                [key]: val?.user_price?.id
            }));
        } else if (key === 'delivery_type' && val === 'currier') {
            setStoreData((pre) => ({
                ...pre,
                [key]: val
            }));
            setSelectedPaymentSystems((s) => {
                if (s?.[0]?.alias === 'warehouse') {
                    return [];
                }
                return s;
            });
        } else {
            setStoreData((pre) => ({
                ...pre,
                [key]: key === 'payment_currency_id' ? val?.id : val
            }));
        }
    }
};

export const deleteProducts = async (
    setAlertData,
    cartData,
    setCartData,
    userToken,
    lang,
    setFormDataError,
    router,
    isOfficeRegister,
    initValue,
    profileData
) => {
    dataSender(
        `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/clear?_method=DELETE`,
        'DELETE',
        false,
        (response) => {
            setCartData(response.data?.data);
            if (router.asPath === getRoute('/store/cart') && !response?.data?.data?.items?.length) {
                navigateV2('/store');
            }
        },
        (data) => {
            setAlertData({
                type: 'error',
                cont: true,
                default: 'error_delete_data'
            });
            if (data.errors && Object.keys(data.errors).length) {
                setFormDataError(data.errors);
            }
        },
        userToken,
        lang,
        isOfficeRegister ? initValue?.country_id?.currency : profileData?.currency?.code
    );
};
export function isMobileUserAgent() {
    if (typeof navigator === 'undefined') return false;

    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}
export const makeOrderFunc = (
    cartData,
    storeData,
    userToken,
    lang,
    setFormDataError,
    setAlertData,
    cartForm,
    myRef,
    newUser,
    setAnswerAfterCheckout,
    func2Fa,
    code,
    translation,
    setAllow,
    localization,
    setPaymentFormData,
    selectedPayment,
    responseComisson,
    updateProfileData,
    payment_type,
    payments,
    payment_currency_id,
    redirect_url,
    setActiveStep,
    partner,
    isOfficeRegister,
    setMbankInfo
) => {
    // debugger;
    // const userParams = ['name', 'second_name', 'phone', 'email'];
    const go = (url) => {
        setTimeout(() => {
            window.location.href = url;
        }, 50);
    };
    let sendData = {};
    // if (userData) {
    //     for (let key in storeData) {
    //         let flag = true;
    //         userParams.map((elem) => {
    //             if (key === elem) {
    //                 flag = false;
    //             }
    //         });
    //         if (flag) {
    //             sendData[key] = storeData[key];
    //         }
    //     }
    // } else {
    sendData = storeData;
    // }
    if (typeof code === 'string') sendData.code = code;
    let accum = {};
    for (let key in sendData) {
        if ((key === 'delivery_country_id' || key === 'delivery_state_id' || key === 'delivery_city_id') && sendData[key]) {
            accum[key] = sendData[key].geoname_id || sendData[key].value;
        } else if (key === 'sponsor_name') {
            if (newUser === 1 && (sendData[key] === null || sendData[key])) {
                accum[key] = sendData[key];
            }
        } else if (key === 'warehouse_id') {
            accum[key] = sendData[key].id;
        } else {
            accum[key] = sendData[key];
        }
    }
    sendData = { ...accum, payment_type, payments };
    if (payment_currency_id) {
        sendData.payment_currency_id = payment_currency_id;
    }
    if (redirect_url) {
        sendData.redirect_url = redirect_url;
    }

    //@TODO
    // const uploadProfileData = new Promise((resolve, reject) => {
    // const userFields = [
    //     ['first_name', 'name'],
    //     ['last_name', 'second_name'],
    //     ['phone', 'phone-code']
    // ];
    // const updateProfileItems = {};
    // userFields.forEach((el) => {
    //     if ((!userData?.[el[0]] && storeData?.[el[1]]?.value) || storeData[el[1]]) {
    //         updateProfileItems[el[0]] = storeData[el[1]]?.value || storeData[el[1]];
    //     }
    // });
    // if (Object.keys(updateProfileItems).length) {
    // }
    // resolve(false);
    // });
    return new Promise((resolve, reject) => {
        dataSender(
            isOfficeRegister
                ? `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/partner-checkout`
                : `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/checkout`,
            'POST',
            { ...sendData, ...(partner ? { user_id: partner?.id } : {}) },
            async (response) => {
                updateProfileData();
                zendoStorage.remove('isOfficeRegister');
                if (!userToken) {
                    navigateV2('/authentication/login');
                } else if (sendData?.payments?.find((item) => item?.type === 'payment' || item?.payment_type === 'payment')) {
                    const data = response?.data;
                    if (data?.data?.links?.payment_form) {
                        getData(data?.data?.links?.payment_form, userToken, lang).then((form) => {
                            if (form.status === 500) {
                                setAllow(true);
                                return setAlertData({
                                    type: 'error',
                                    cont: t(
                                        'error-msg-stripe',
                                        'Пополняемая сумма должна быть больше 0.5$ по текущему курсу - смените сумму пополнения или обратитесь к администратору',
                                        '/store',
                                        translation
                                    )
                                });
                            }
                            const temp = sendData?.payments?.find((item) => item?.payment_type === 'payment');
                            const paymentSystemFull = sendData?.paymentData?.find((pay) => pay?.id == temp?.payment_id);
                            if (paymentSystemFull?.alias === 'gtpaymentkaspi') {
                                axios({
                                    url: `${SITE_URL}/api/kaspi`,
                                    method: 'POST',
                                    data: {
                                        action: form?.data?.action,
                                        data: form?.data?.fields
                                    }
                                })
                                    .then((response) => {
                                        zendoStorage.set(
                                            'kaspi',
                                            JSON.stringify({
                                                orderId: data?.data?.number,
                                                amount: form?.data?.formatted?.amount,
                                                link: response?.data?.data?.redirectUrl
                                            })
                                        );
                                        navigateV2(`/store/redirect?type=kaspi`);
                                    })
                                    .catch((error) => {
                                        setAlertData({
                                            type: 'error',
                                            cont: error?.message || <T textName='Произошла ошибка' defaultStr='error_occured' />
                                        });
                                        setAllow(true);
                                    });
                                return;
                            }
                            if (form?.data?.payment_system_alias !== 'coinpayment') {
                                if (form?.data?.url && form?.data?.url?.includes('homebank')) {
                                    if (isMobileUserAgent()) {
                                        go(form?.data?.url);
                                    } else {
                                        navigateV2(
                                            `/store/order?type=halyk&id=${data?.data?.number}&url=${form?.data?.url}&sum=${response?.data?.data?.payment_system_document?.payment_amount_formatted}`
                                        );
                                    }
                                } else if (form?.data?.payment_system?.alias == 'gtpaymentmbank') {
                                    setMbankInfo({
                                        ...form?.data,
                                        number: response.data.data?.number
                                    });
                                } else {
                                    setAlertData({
                                        type: 'success',
                                        cont: t('alertSuccessMakeOrder', 'Заказ успешно создан', '/store', translation)
                                    });
                                }
                            }
                            if (form?.data[0]?.key === 'action') {
                                let accum = { data: {} };
                                if (form?.data?.length > 0) {
                                    form?.data.forEach((item) => {
                                        if (item?.key !== 'action' && item?.key !== 'method_form') {
                                            accum.data[item?.key] = item?.value;
                                        } else {
                                            accum[item?.key] = item?.value;
                                        }
                                    });
                                }
                                setPaymentFormData(accum);
                                return;
                            }
                            if (form?.data?.action) {
                                let redirectUrl = `https:${form.data.action}?`;
                                let count = 0;
                                for (let param in form.data) {
                                    if (param !== 'action') {
                                        count++;

                                        let filter = `${param}=${form.data[param]}`;
                                        if (Object.keys(form.data).length - count > 1) {
                                            filter += '&';
                                        }
                                        redirectUrl += filter;
                                    }
                                }

                                if (redirectUrl) {
                                    document.location = redirectUrl;
                                }
                            } else if (form?.data?.redirect) {
                                document.location = form?.data?.redirect;
                            } else if (
                                form?.data?.length &&
                                (form.data[0].value.includes('portmone') ||
                                    form.data[0].value.includes('liqpay') ||
                                    form.data[0].value.includes('robokassa'))
                            ) {
                                let accum = {};
                                form?.data.map((idx) => {
                                    if (idx.key !== 'action' && idx.key !== 'method_form') {
                                        accum[idx.key] = idx.value;
                                    }
                                });
                                htmlFormSend(`${form.data[0].value}`, accum);
                            } else if (form?.data?.length && form.data[0].value.includes('charge')) {
                                const pay = function () {
                                    if (typeof cp === 'undefined') {
                                        setAlertData({
                                            type: 'error',
                                            cont: t(
                                                'alertSErrorCloudPayments',
                                                'Ошибка оплаты с помощью CloudPayments',
                                                '/store',
                                                translation
                                            )
                                        });
                                    } else {
                                        /* eslint-disable no-undef */
                                        var widget = new cp.CloudPayments();
                                        widget.pay(
                                            `${form.data[0].value}`,
                                            {
                                                publicId: `${form.data[1].value}`, //id из личного кабинета
                                                description: `${form.data[4].value}`, //назначение
                                                amount: Number(`${form.data[2].value}`), //сумма
                                                currency: `${form.data[3].value}`, //валюта
                                                invoiceId: `${form.data[5].value}`, //номер заказа  (необязательно)
                                                skin: `${form.data[6].value}` //дизайн виджета (необязательно)
                                            },
                                            {
                                                onSuccess: `${form.data[7].value}`,
                                                onFail: `${form.data[8].value}`
                                            }
                                        );
                                    }
                                };
                                pay();
                            } else if (form?.data?.payment_system_alias === 'coinpayment') {
                                setShowPayment(form?.data);
                            } else if (
                                form?.data &&
                                data?.data?.payments.some((item) => item?.resource?.accept_cryptocurrency_payments)
                            ) {
                                const currTime = form?.data?.expire_at - form?.data?.created_at;

                                const expireTime = moment().add(currTime / 60, 'minutes');

                                localStorage.setItem(
                                    'answerAfterCheckout',
                                    JSON.stringify({
                                        data: { ...form?.data, expireTime },
                                        responseComisson,
                                        selectedPayment,
                                        cartData: cartData.id
                                    })
                                );
                                setAnswerAfterCheckout({
                                    ...form?.data,
                                    expireTime
                                });
                            }
                            if (!form?.data) {
                                setAlertData({
                                    type: 'error',
                                    cont: true,
                                    default: 'error_get_data'
                                });
                            }
                        });
                    }
                    const paymentSystem = sendData?.payments?.find((item) => item?.payment_type === 'payment');
                    if (
                        paymentSystem &&
                        storeData?.paymentData?.find((item) => item.id === paymentSystem.payment_id)?.payment_type === 'manual'
                    ) {
                        if (isOfficeRegister) {
                            zendoStorage.set('orderFromOfficeRegister', JSON.stringify(data?.data), true);
                        }
                        navigateV2(`/store/order/requisites/${data?.data?.id}`);
                    }
                } else {
                    setAlertData({
                        type: 'success',
                        cont: t('alertSuccessMakeOrder', 'Заказ успешно создан', '/store', translation)
                    });
                    navigateV2(
                        `/store/order?id=${response.data.data?.number || response.data.data.id}${
                            isOfficeRegister ? '&pageFrom=register' : ''
                        }`
                    );
                }
                resolve();
            },
            (data) => {
                if (!data?.errors) {
                    setAlertData({
                        type: 'error',
                        cont: t(
                            'error-type-message-500',
                            'Нет связи с платежной системой. Сообщить об ошибке можно на странице "Контакты"',
                            '/store',
                            translation
                        )
                    });

                    setAllow(true);
                }
                setAllow(true);
                if (data?.errors?.code && !data.errors.items) {
                    func2Fa();
                    reject(data?.errors?.code);
                }
                if (data.errors && Object.keys(data.errors).length) {
                    setFormDataError(data.errors);
                    let activeRef = 1;
                    const blocksWithErrors = [];
                    cartForm.map((elem) => {
                        let trigger = false;
                        elem.field.forEach((el) => {
                            if (Object.keys(data.errors).some((item) => item === el)) {
                                trigger = true;
                            }
                        });

                        if (trigger) {
                            blocksWithErrors.push(elem);
                            activeRef = elem.id;
                        }
                    });
                    const index = blocksWithErrors.length > 0 ? blocksWithErrors[0].id - 1 : activeRef - 1;
                    if (myRef.current[index]) {
                        myRef.current[index].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
                if (data.errors?.items) {
                    setAlertData({
                        type: 'error',
                        cont: data.errors.items?.join(' ')
                    });
                    setActiveStep((s) => s - 1);
                }
                reject([]);
            },
            userToken,
            lang,
            localization?.currency
        );
    });
};
